export class IUserService {
  // Distributor-related methods
  getUsers = async () => {};
  getUser = async () => {};
  createUser = async () => {};
  updateUser = async () => {};
  updateUserStatus = async () => {};

  // Internal user management
  getInternalUsers = async () => {};
  getInternalUser = async () => {};
  createInternalUser = async () => {};
  updateInternalUser = async () => {};
  updateInternalUserStatus = async () => {};

  // Dropdowns and supporting data
  populateDropdownOptions = async () => {};
}
